import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { take, takeUntil, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DateTime } from 'luxon';

import { PopupRangeService } from '../../utils/popup-range.service';
import { PopupCalendarConfig, PopupRangeStore } from '../../utils';

@Component({
    selector: 'aa-hour-selector',
    templateUrl: './hour-selector.component.html',
    styleUrls: [
        './hour-selector.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HourSelectorComponent implements OnInit, OnDestroy
{
    private static regexpNumber = /[0-9]/;
    @Input() isSinceCalendar: boolean;
    public cfg: PopupCalendarConfig = new PopupCalendarConfig();
    // public hour: number = 0;
    // public minute: number = 0;
    public formGroup: UntypedFormGroup;
    private destroyator = new Subject();
    public readonly hourField: string = 'hour';
    public readonly minuteField: string = 'minute';

    constructor (
        private popupRangeService: PopupRangeService,
        private fb: UntypedFormBuilder
    )
    {
    }

    ngOnInit (): void
    {
        this.popupRangeService.rangeConfig
            .pipe(
                take(1),
                tap((prs: PopupRangeStore) =>
                {
                    const currentDate: DateTime = this.isSinceCalendar ? prs.currentSince : prs.currentUntil;

                    this.createForm(currentDate.hour, currentDate.minute);
                })
            )
            .subscribe();
    }

    ngOnDestroy ()
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    public doNameChange (event: any)
    {
        // console.debug({ event });
    }

    private createForm (hour: number, minute: number)
    {
        this.formGroup = this.fb.group({
            [this.hourField]: [hour],
            [this.minuteField]: [minute] // new FormControl(this.minute, Validators.required)
        });
        this.formListener();
    }
    private formListener ()
    {
        this.formGroup.get(this.hourField).valueChanges
            .pipe(
                tap((hour: number) =>
                {
                    if (hour < 0)
                    {
                        hour = 0;
                        this.formGroup.patchValue({ hour }, { emitEvent: false });
                    }

                    if (hour > 23)
                    {
                        hour = 23;
                        this.formGroup.patchValue({ hour }, { emitEvent: false });
                    }

                    this.popupRangeService.setHour(this.isSinceCalendar, hour);
                }),
                takeUntil(this.destroyator)
            )
            .subscribe();
        this.formGroup.get(this.minuteField).valueChanges
            .pipe(
                tap((minute: number) =>
                {
                    if (minute < 0)
                    {
                        minute = 0;
                        this.formGroup.patchValue({ minute }, { emitEvent: false });
                    }

                    if (minute > 59)
                    {
                        minute = 59;
                        this.formGroup.patchValue({ minute }, { emitEvent: false });
                    }

                    this.popupRangeService.setMinute(this.isSinceCalendar, minute);
                }),
                takeUntil(this.destroyator)
            )
            .subscribe();
    }

    public onKeyPressHour (event: any)
    {
        const inputCharacter = String.fromCharCode(event.charCode);

        if (event.keyCode != 8 && !HourSelectorComponent.regexpNumber.test(inputCharacter))
        {
            event.preventDefault();
        }
    }

    public onKeyPressMinute (event: any)
    {
        const inputCharacter = String.fromCharCode(event.charCode);

        if (event.keyCode != 8 && !HourSelectorComponent.regexpNumber.test(inputCharacter))
        {
            event.preventDefault();
        }
    }
}
